import { useGetApi, useMutateApi } from "../hooks";
import subscribeApi, { SubscribeResponse } from "../../api/subscribe/subscribeApi";

export type UseGetSubscriptionResponse = {
  enabled?: boolean;
  onSuccess?: (data: SubscribeResponse) => void;
  onError?: (error: unknown) => void;
};



export const useGetSubscription = ({
  enabled,
  onSuccess,
  onError,
}: UseGetSubscriptionResponse) =>
  useGetApi<SubscribeResponse>({
    fetch: subscribeApi.getSubscription,
    key: ["subscribeApi.getSubscription"],
    enabled,
    onSuccess,
    onError,
  });
  


export const useGetToken = ({
  enabled = true,
  onSuccess,
  onError,
  TOKEN,
}: UseGetSubscriptionResponse & { enabled?: boolean, TOKEN?: string}) =>
  useGetApi<SubscribeResponse>({
    fetch: () => subscribeApi.getToken(TOKEN || ""),
    key: ["subscribeApi.getToken", TOKEN ],
    enabled,
    onSuccess,
    onError,
  });

